import axios from 'axios';

const apiUrl = `https://hirecrap-backend-gcg3e8cmcgfwe6ef.westus2-01.azurewebsites.net/api`;

// Reusable API fetch function with caching
const fetchFromAPI = async (url, params = {}) => {
    try {
        const response = await axios.get(url, { params, timeout: 15000 });
        return response.data;
    } catch (error) {
        console.error(`Error fetching data from ${url}:`, error.message);
        throw error;
    }
};

export const getInJoobleJobDetails = async (id) => {
    return fetchFromAPI(`${apiUrl}/jooblein/jobById/${id}`);
};

export const getInJoobleJobs = async (page = 1, limit = 50) => {
    return fetchFromAPI(`${apiUrl}/jooblein/alljobs`, { page, limit });
};


export const getInJoobleJobsByTitle = async (title) => {
    return fetchFromAPI(`${apiUrl}/jooblein/search`, { title});
};